import React from "react";
import PropTypes from "prop-types";

import Popper from "components/Popper";

// eslint-disable-next-line max-len
import NextWorkflowConditionsGroupView from "scenes/Hubly/components/Workspace/components/WorkflowContainer/components/WorkflowEditor/components/NextWorkflowsEditor/components/NextWorkflowConditionsGroupView";

import { ConditionalNextWorkflowsTile } from "./components";

function NextWorkflowClientCardConditionsGroupView({
  clientWorkflowId,
  nextWorkflowGroup,
}) {
  if (!nextWorkflowGroup?.conditions?.length) return null;

  return (
    <Popper
      on="hover"
      hoverable
      position="left center"
      flowing
      trigger={
        <div style={{ width: "calc(100% - 1em)" }}>
          <ConditionalNextWorkflowsTile
            nextWorkflows={nextWorkflowGroup?.nextWorkflow}
          />
        </div>
      }
    >
      <NextWorkflowConditionsGroupView
        nextWorkflowGroup={nextWorkflowGroup}
        workflowId={clientWorkflowId}
        disabled
        showIcon={false}
        onConfigChange={() => {}}
        onOrderModified={() => {}}
      />
    </Popper>
  );
}

NextWorkflowClientCardConditionsGroupView.propTypes = {
  clientWorkflowId: PropTypes.string.isRequired,
  nextWorkflowGroup: PropTypes.shape({
    conditions: PropTypes.array,
    nextWorkflow: PropTypes.array,
  }),
};

NextWorkflowClientCardConditionsGroupView.defaultProps = {
  nextWorkflowGroup: null,
};

export default NextWorkflowClientCardConditionsGroupView;
